/** スマホの見積の画面のアイコン（24×24 の線。太さ・色は置いた場所の CSS の .phi。Figma「見積（スマホ・PC）10/3」の icon/…） */
export type PhIconKey = "camera" | "image" | "msg" | "hat" | "people" | "chevD" | "chevL" | "chevR" | "more" | "plus" | "search" | "send" | "up" | "down" | "trash" | "x" | "clock" | "check";

export function PhIcon({ k, className }: { k: PhIconKey; className?: string }) {
  const p = {
    camera: (
      <>
        <path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3z" />
        <circle cx="12" cy="13" r="3.5" />
      </>
    ),
    image: (
      <>
        <rect x="3" y="3" width="18" height="18" rx="2" />
        <circle cx="9" cy="9" r="2" />
        <path d="M21 15l-3.1-3.1a2 2 0 0 0-2.8 0L6 21" />
      </>
    ),
    msg: <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />,
    hat: (
      <>
        <path d="M2 18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1z" />
        <path d="M10 10V5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v5M4 15v-3a6 6 0 0 1 6-6M14 6a6 6 0 0 1 6 6v3" />
      </>
    ),
    /** 相手（{vendor}）の汎用の印：人の形（#142 段6 参考：ヘルメット hat は現場力＝field の会社だけ） */
    people: (
      <>
        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M22 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" />
      </>
    ),
    chevD: <path d="M6 9l6 6 6-6" />,
    chevL: <path d="M15 18l-6-6 6-6" />,
    chevR: <path d="M9 18l6-6-6-6" />,
    more: (
      <>
        <circle cx="12" cy="5" r="1.2" />
        <circle cx="12" cy="12" r="1.2" />
        <circle cx="12" cy="19" r="1.2" />
      </>
    ),
    plus: <path d="M12 5v14M5 12h14" />,
    search: (
      <>
        <circle cx="11" cy="11" r="7" />
        <path d="M20 20l-4-4" />
      </>
    ),
    send: <path d="M22 2L11 13M22 2l-7 20-4-9-9-4z" />,
    up: <path d="M12 19V5M5 12l7-7 7 7" />,
    down: <path d="M12 5v14M19 12l-7 7-7-7" />,
    trash: <path d="M3 6h18M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6M10 11v6M14 11v6" />,
    x: <path d="M18 6L6 18M6 6l12 12" />,
    clock: (
      <>
        <circle cx="12" cy="12" r="9" />
        <path d="M12 7v5l3 2" />
      </>
    ),
    check: <path d="M20 6L9 17l-5-5" />,
  }[k];
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" className={"phi" + (className ? ` ${className}` : "")}>
      {p}
    </svg>
  );
}
